import React from 'react'
import { AutoCompleterV3, AutoCompleterConfig } from '../../../components/_WMS/AutoCompleterV3'
import { SupplierOrigin } from '../../../interfaces/Supplier/SupplierOrigin/SupplierOrigin'
import { ComponentProps } from '../../../components/_WMS/FilterComponent/types'
import { createFilterValueWithDisplay } from '../../../types/filters'
import { ApiConfig } from '../../../config/api'

const supplierOriginConfig: AutoCompleterConfig<SupplierOrigin> = {
  searchEndpoint: `${ApiConfig.SupplierOriginApi}/search`,
  searchParam: 'q',
  keyField: 'supplierOriginId',
  displayField: 'supplierOriginName',
  minSearchLength: 2,
  debounceMs: 300,
  pageSize: 5  // El backend devuelve top 5, así que ajustamos el pageSize
}

export const SupplierOriginAutoCompleter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  transformForBackend,
  transformForDisplay
}) => {
  const [selectedSupplierOrigin, setSelectedSupplierOrigin] = React.useState<SupplierOrigin | null>(null)

  // Sincronizar con el valor externo cuando cambie
  React.useEffect(() => {
    if (value && value !== selectedSupplierOrigin?.supplierOriginId.toString()) {
      // Si hay un valor pero no coincide con el seleccionado, limpiar
      setSelectedSupplierOrigin(null)
    }
  }, [value, selectedSupplierOrigin])

  const handleSupplierOriginChange = (supplierOrigin: SupplierOrigin | null) => {
    setSelectedSupplierOrigin(supplierOrigin)

    // Si hay transformadores disponibles, usar el enfoque JSON para compatibilidad con FilterComponent
    // Si no, usar el valor simple (para casos donde se use fuera de FilterComponent)
    let eventValue = ''
    if (supplierOrigin) {
      if (transformForBackend && transformForDisplay) {
        // Usar función tipada para FilterComponent
        eventValue = createFilterValueWithDisplay(
          supplierOrigin.supplierOriginId,
          `${supplierOrigin.supplierOriginName} (${supplierOrigin.supplierName})`
        )
      } else {
        // Usar valor simple para otros casos
        eventValue = supplierOrigin.supplierOriginId.toString()
      }
    }

    const syntheticEvent = {
      target: {
        value: eventValue,
        name: 'supplierOriginId'
      }
    } as React.ChangeEvent<HTMLInputElement>

    onChange(syntheticEvent)
  }

  const renderOption = (supplierOrigin: SupplierOrigin) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div style={{ fontWeight: 'bold' }}>{supplierOrigin.supplierOriginName}</div>
      <div style={{ fontSize: '0.875rem', color: '#666' }}>
        Proveedor: {supplierOrigin.supplierName}
      </div>
    </div>
  )

  const renderValue = (supplierOrigin: SupplierOrigin) =>
    `${supplierOrigin.supplierOriginName} (${supplierOrigin.supplierName})`

  return (
    <AutoCompleterV3<SupplierOrigin>
      config={supplierOriginConfig}
      value={selectedSupplierOrigin}
      onChange={handleSupplierOriginChange}
      placeholder="Buscar origen de proveedor..."
      renderOption={renderOption}
      renderValue={renderValue}
      width={fullWidth ? "100%" : 300}
    />
  )
}
